import { FC } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import QRCode from 'qrcode.react';
import { getUserInfo } from 'utils/auth';
import { useTranslation } from 'react-i18next';
import { useLanguageContext } from 'store/language';
import InstructionsBG from './InstructionsBG';
import InstructionsEN from './InstructionsEN';
import CodeValidationForm from './CodeValidationForm';

interface IProps {
  qrCode: string;
  secretKey: string;
}

const Content: FC<IProps> = ({ qrCode, secretKey }: IProps) => {
  const { t } = useTranslation();
  const { language } = useLanguageContext();
  const userInfo = getUserInfo();
  return (
    <Row>
      {/* Stack the columns on mobile by making one full-width and the other half-width */}
      <Col
        xs={12}
        md={8}
      >
        <Row className="mb-4">
          <Col xs={2}>
            <p className="text-right">{t('twoFA.instructions')}</p>
          </Col>
          <Col xs={10}>
            {language === 'bg' && <InstructionsBG />}
            {language === 'en' && <InstructionsEN />}
          </Col>
        </Row>
        <Row className="mb-4">
          <Col xs={2}>
            <p className="text-right">{t('twoFA.QRcode')}</p>
          </Col>
          <Col xs={10}>
            <QRCode value={qrCode} />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col xs={2}>
            <p className="text-right">{t('twoFA.manualVerification')}</p>
          </Col>
          <Col xs={10}>
            <p className="mb-0">
              <b>Account:</b> {userInfo.email}
            </p>
            <p>
              <b>Key:</b> {secretKey}
            </p>
          </Col>
        </Row>
        <CodeValidationForm />
      </Col>
    </Row>
  );
};

export default Content;
